import Vue from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import axios from 'axios';
import { APIVars } from './config.js';
import { mapGetters, mapState } from 'vuex';
import { mapActions } from 'vuex';
// import * as Sentry from '@sentry/browser';
// import * as Integrations from '@sentry/integrations';
import './registerServiceWorker.js';
import VueApexCharts from 'vue-apexcharts';
import VueTimers from 'vue-timers';
import updatemix from './mixins/update'
import VueGeolocation from 'vue-browser-geolocation';
import VueMoment from 'vue-moment'
import moment from 'moment-timezone'
import TopMenu from './components/TopMenu'


Vue.use(VueGeolocation);

Vue.use(VueTimers);

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);
Vue.component('top-menu', TopMenu);

Vue.use(VueMoment, {
    moment,
})

Vue.mixin(updatemix);

// Sentry.init({
//   dsn: 'https://ea82872a5fa74c3b83fe5d03e9cfc48c@sentry.awskbbapps.kbb.com/4',
//   integrations: [new Integrations.Vue({Vue, attachProps: true, logErrors: true})],
// });

Vue.config.productionTip = false;
Vue.prototype.$https = axios;
Vue.prototype.$vars = APIVars;

// inject a handler for `myOption` custom option
Vue.mixin({
  computed: {
    ...mapState({
     // arrow functions can make the code very succinct!
     loggedIn: state => state.userinfo.loggedIn,
     selWing: state => state.wing,
     userInfo: state => state.userinfo.cognitoInfo,
     appsettings: state => state.appSettings,
     lookupUnits: state => state.tempUnits,
     lookupICs: state => state.tempICList,
     lookupAircraft: state => state.tempAircraftList,
     lookupAircraftMx: state => state.tempAircraftMxList,
     lookupFROList: state => state.tempFROList,
     lookupCheckPilotTypes: state => state.tempCheckPilotTypes,
     lookupCheckPilotList: state => state.tempCheckPilotList,
     getCallsignSearch: state => state.tempCallSignSearch,
     usercapid: state => state.userinfo.capid,
     menuperms: state => state.MenuPermissions,
     unitswithgroups: state => state.UnitsWithGroups,
     appUpdateNeeded: state =>state.appUpdateNeeded,
   }),
   ...mapGetters({
    globalIndex: 'getGlobalIndex',
    previousRoute: 'getPreviousRoute'
   })
 },
 methods: {
  ...mapActions({
    setBackButtonVisibility: 'updateBackButtonVisibility', // map `this.setBackButtonVisibility()` to `this.$store.dispatch('updateBackButtonVisibility',payload)`
    setHomeButtonVisibility: 'updateHomeButtonVisibility', // map `this.setBackButtonVisibility()` to `this.$store.dispatch('updateBackButtonVisibility',payload)`
    setUnitList: 'updateUnitList',
    setZoneList: 'updateZoneList', // map `this.setBackButtonVisibility()` to `this.$store.dispatch('updateBackButtonVisibility',payload)`
    setICList: 'updateICList',
    setAircraftList: 'updateAircraftList',
    setAircraftMxList: 'updateAircraftMxList',
    setFROList: 'updateFROList',
    setCheckPilotTypes: 'updateCheckPilotTypes',
    setCheckPilotList: 'updateCheckPilotList',
    setTempCallsignSearch: 'updateCallsignSearch',
    setGlobalIndex: 'updateGlobalIndex',
    setAppUpdateNeeded: 'updateAppUpdateNeededVar',
    setSelWing: 'updateSelWing',
    setPreviousRoute: 'updatePreviousRoute'
  }),
 }
});

Vue.directive('uppercase',
{
  inserted: function(el, _, vnode) {
    el.addEventListener('input', function(e) {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit('input', e.target.value.toUpperCase());
    });
  }
});

Vue.directive('trimmed',
{
  inserted: function(el, _, vnode) {
    el.addEventListener('input', function(e) {
      e.target.value = e.target.value.trim();
      vnode.componentInstance.$emit('input', e.target.value.trim());
    });
  }
});

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');


